module.exports = __webpack_public_path__ + "img/9.610d3523.png";